<!-- Zoom -->
<button
	*ngIf="activeItem"
	mat-mini-fab
	class="button-extra-small mr-3"
	color="tertiary"
	matTooltip="Zoom"
	i18n-matTooltip="Zoom Button@@adPreviewNavigationZoomButton"
	[matMenuTriggerFor]="zoomMenu"
>
	<mat-icon>zoom_in</mat-icon>
</button>
<mat-menu #zoomMenu="matMenu">
	<!-- <button (click)="previewScaleChange.emit(PREVIEW_SCALE_MIN_VALUE); $event.stopImmediatePropagation()" mat-menu-item>
		<span i18n="Zoom Button Small@@adPreviewZoomButtonSmall">Small</span>
	</button> -->

	<!-- <button (click)="previewScaleChange.emit(PREVIEW_SCALE_MAX_VALUE); $event.stopImmediatePropagation()" mat-menu-item>
		<span i18n="Zoom Button Large@@adPreviewZoomButtonLarge">Large</span>
	</button> -->
	<div class="zoom-controls">
		<button
			mat-button
			class="size-small"
			[disabled]="parseFloatValue(getPreviewScaleValue()) <= PREVIEW_SCALE_MIN_VALUE"
			(click)="handleZoomOut(); $event.stopImmediatePropagation()"
		>
			<mat-icon class="ml-2">remove</mat-icon>
		</button>
		<mat-slider
			[min]="PREVIEW_SCALE_MIN_VALUE"
			[max]="PREVIEW_SCALE_MAX_VALUE"
			[step]="PREVIEW_SCALE_STEP"
			[ngModel]="getPreviewScaleValue()"
			#sliderScale
			id="sliderScale"
			(ngModelChange)="previewScaleChange.emit(sliderScale.value)"
			(click)="$event.stopImmediatePropagation()"
		>
		</mat-slider>
		<button
			mat-button
			class="size-small"
			[disabled]="parseFloatValue(getPreviewScaleValue()) >= PREVIEW_SCALE_MAX_VALUE"
			(click)="handleZoomIn(); $event.stopImmediatePropagation()"
		>
			<mat-icon class="ml-2">add</mat-icon>
		</button>
	</div>

	<button
		(click)="handleZoomReset(); $event.stopImmediatePropagation()"
		mat-menu-item
	>
		<span i18n="Zoom Button@@adPreviewZoomFitToWindow">Reset</span>
	</button>
	<button
		(click)="handleZoomFill(); $event.stopImmediatePropagation()"
		mat-menu-item
	>
		<span i18n="Zoom Button@@adPreviewZoomToFillWindow">Zoom to Fill Window</span>
	</button>
</mat-menu>

<button
	*ngIf="!activeItem"
	mat-mini-fab
	class="button-extra-small mr-3"
	color="tertiary"
	matTooltip="Zoom"
	i18n-matTooltip="Zoom Button@@adPreviewNavigationZoomButtonTooltip"
	[matMenuTriggerFor]="zoomMenuAllTab"
>
	<mat-icon>zoom_in</mat-icon>
</button>
<mat-menu #zoomMenuAllTab="matMenu">
	<button (click)="previewMaxHeightChange.emit(MAX_HEIGHT_MIN_VALUE); $event.stopImmediatePropagation()" mat-menu-item>
		<span i18n="Zoom Button Tiny@@adPreviewZoomButtonTiny">Tiny</span>
	</button>
	<button
		(click)="previewMaxHeightChange.emit(MAX_HEIGHT_SMALL_VALUE); $event.stopImmediatePropagation()"
		mat-menu-item
	>
		<span i18n="Zoom Button Small@@adPreviewZoomButtonSmall">Small</span>
	</button>
	<button
		(click)="previewMaxHeightChange.emit((MAX_HEIGHT_MAX_VALUE + MAX_HEIGHT_MIN_VALUE) / 2); $event.stopImmediatePropagation()"
		mat-menu-item
	>
		<span i18n="Zoom Button Medium@@adPreviewZoomButtonMedium">Medium</span>
	</button>
	<button (click)="previewMaxHeightChange.emit(MAX_HEIGHT_MAX_VALUE); $event.stopImmediatePropagation()" mat-menu-item>
		<span i18n="Zoom Button Large@@adPreviewZoomButtonLarge">Large</span>
	</button>
	<div class="zoom-controls">
		<button
			mat-button
			class="size-small"
			[disabled]="previewMaxHeight <= MAX_HEIGHT_MIN_VALUE"
			(click)="previewMaxHeightChange.emit(previewMaxHeight - MAX_HEIGHT_CHANGE_STEP); $event.stopImmediatePropagation()"
		>
			<mat-icon class="ml-2">remove</mat-icon>
		</button>
		<mat-slider
			[min]="MAX_HEIGHT_MIN_VALUE"
			[max]="MAX_HEIGHT_MAX_VALUE"
			[ngModel]="previewMaxHeight"
			#sliderScaleAllTab
			id="sliderScaleAllTab"
			(ngModelChange)="previewMaxHeightChange.emit(sliderScaleAllTab.value)"
			(click)="$event.stopImmediatePropagation()"
		>
		</mat-slider>

		<button
			mat-button
			class="size-small"
			[disabled]="previewMaxHeight >= MAX_HEIGHT_MAX_VALUE"
			(click)="previewMaxHeightChange.emit(previewMaxHeight + MAX_HEIGHT_CHANGE_STEP); $event.stopImmediatePropagation()"
		>
			<mat-icon class="ml-2">add</mat-icon>
		</button>
	</div>
</mat-menu>
